import { render, staticRenderFns } from "./FarmersList.vue?vue&type=template&id=60fcf620&scoped=true"
import script from "./FarmersList.vue?vue&type=script&lang=js"
export * from "./FarmersList.vue?vue&type=script&lang=js"
import style0 from "./FarmersList.vue?vue&type=style&index=0&id=60fcf620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fcf620",
  null
  
)

export default component.exports